import { Button, Flex, Progress, Text } from '@mantine/core';
import {
	H3,
	StepContainer,
} from '@dealstack/frontend/shared/components/Documents/UploadDocuments/styled';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { UploadContainer } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/UploadCompleteStep/styled';
import { UploadStats } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/UploadStats';
import { FindRelatedFilesRes } from '@dealstack/shared/lib/generated';
import { FileWithClassifier } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/AddFileStep/types';
import { DuplicateFile } from '@dealstack/frontend/shared/components/Documents/types';
import { DOCUMENT_LIBRARY_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';

interface Props {
	setIsUploadActive: (isActive: boolean) => void;
	uploadFileData: FileWithClassifier[];
	isUploadingFiles: boolean;
	localDuplicateFiles: {
		filesWithDuplicates: DuplicateFile[];
		totalDuplicates: number;
	};
	relatedFilesInDeal: FindRelatedFilesRes[] | undefined;
	uploadProgress: number;
	clearDocumentState: () => void;
}

export const UploadCompleteStep = ({
	setIsUploadActive,
	uploadFileData,
	isUploadingFiles,
	localDuplicateFiles,
	relatedFilesInDeal,
	uploadProgress,
	clearDocumentState,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<StepContainer data-testid={DOCUMENT_LIBRARY_ELEMENT_ID.UPLOAD_COMPLETE_STEP}>
			<UploadContainer>
				{isUploadingFiles && (
					<>
						<H3>{tCapManage('document.upload_complete.header.in_process')}</H3>
						<Text mb="1.5rem" size="0.875rem" fw={400}>
							{tCapManage('document.upload_complete.subheader.in_process')}
						</Text>
						<div style={{ width: '50rem', textAlign: 'center' }}>
							<Progress size="xl" value={uploadProgress} />
						</div>
						{Math.round(uploadProgress)}%
					</>
				)}
				{!isUploadingFiles && (
					<Flex direction="column" align="center" justify="center">
						<Icon variant="document-uploaded" size="12.375rem" />
						<H3>{tCapManage('document.upload_complete.header.done')}</H3>
						<Text mb="1.5rem" size="0.875rem" fw={400}>
							{tCapManage('document.upload_complete.subheader.done')}
						</Text>
						<UploadStats
							uploadFileData={uploadFileData}
							localDuplicateFiles={localDuplicateFiles}
							relatedFilesInDeal={relatedFilesInDeal}
						/>
						<Flex w="100%">
							<Button
								data-testid={
									DOCUMENT_LIBRARY_ELEMENT_ID.UPLOAD_COMPLETE_CONFIRM_BUTTON
								}
								w="100%"
								mt="1.5rem"
								onClick={() => {
									clearDocumentState();
									setIsUploadActive(false);
								}}
							>
								{tCapManage('document.upload_complete.button.confirm')}
							</Button>
						</Flex>
					</Flex>
				)}
			</UploadContainer>
		</StepContainer>
	);
};
